const RECOVERY_FLAG = 'isbd_password_recovery';

/** Mémorise une demande de reset (même navigateur que le clic e-mail). */
export function markPasswordRecoveryPending() {
  try {
    sessionStorage.setItem(RECOVERY_FLAG, '1');
  } catch {
    /* private mode / storage full */
  }
}

export function consumePasswordRecoveryPending(): boolean {
  try {
    const v = sessionStorage.getItem(RECOVERY_FLAG);
    sessionStorage.removeItem(RECOVERY_FLAG);
    return v === '1';
  } catch {
    return false;
  }
}
